import * as React from 'react';
import {Size} from '../types';
import { DropdownItem } from '../Dropdown/DropdownContent';

export interface NestedNavItemProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'id' | 'disabled' | 'onMouseDown' | 'onClick'> {
  /**
   * Required. The item to be displayed in the dropdown.
   */
  item: DropdownItem;

  /**
   * Required. The handler function to be called when the item is clicked.
   */
  onClickHandler: (e: React.MouseEvent) => void;

  /**
   * Required. A boolean indicating whether the item is currently active.
   */
  active: boolean;

  /**
   * Required. The unique identifier for the item.
   */
  id: string;

  /**
   * Optional. The size of the item. Defaults to 'Medium'.
   */
  size?: Size;

  /**
   * Optional. An icon to be displayed on the right side of the item.
   */
  iconRight?: React.ReactElement<any>;
}


const NestedNavItem = React.forwardRef<HTMLButtonElement, NestedNavItemProps>(({
                                                                       active,
                                                                       item,
                                                                       onClickHandler,
                                                                       size = Size.Medium,
                                                                       className,
                                                                       tabIndex,
                                                                       iconRight,
                                                                       id,
                                                                       ...rest
                                                                     }: NestedNavItemProps, ref) => {
  return (
   <></>
  );
});

export default NestedNavItem;
